<div id="category-layout-55555" class="category-page-layout-2 style-category-layout-55555 dynamic-listing-page-theme">
    @if (page() === DynamicPage.SEARCH) {
    <div class="search-result-heading">
        <p class="search-result-text-size search-result-text-color search-result-font-weight search-result-text-transform">
            Search result for:<span class="search-value-text-size search-value-text-color search-value-font-weight search-value-text-transform">
                {{ searchValue() }}</span>
        </p>
    </div>
    }

    <div [hidden]="
      (!products().length && !currentAppliedFilters().length) ||
      (pageLoading() && ((isMobile() && !mobileFilterOpened) || !isMobile()))
    ">
        <div class="hide-on-mobile">
            <app-category-filter-layout-2 [category]="category()" [availableFilterAttributes]="availableFilterAttributes()" [currentAppliedFilters]="currentAppliedFilters()"></app-category-filter-layout-2>
        </div>

        <div class="category-page-content">
            <!-- sorting panel -->
            <sorting-layout-1 [category]="category()" [sortOptions]="sortOptions()" [sortBy]="sortBy()" [totalProductsCount]="totalProductsCount()" [fetchedProductsCount]="fetchedProductsCount()" [availableFilterAttributes]="availableFilterAttributes()" [currentAppliedFilters]="currentAppliedFilters()" [categoryLayoutData]="categoryLayoutData()" (selectedGridViewLayoutChange$)="changeGridViewLayout($event)" (mobileFilterOpened$)="mobileFilterOpened = $event" (sortByChange$)="onSortByChange($event)" [selectedGridViewLayout]="currentGridViewLayout()"></sorting-layout-1>

            <section class="listing-section">
                @if (!pageLoading() && !productLoading()) {
                <div class="product-listing-container editable">
                    @if (
                    currentGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT1 ||
                    currentGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT2 ||
                    currentGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT4
                    ) {
                    @for (product of products(); track product?._id) {
                    <product-card-square [selectedGridViewLayout]="currentGridViewLayout()" [categoryLayoutData]="categoryLayoutData()" [selectedMobileGridLayout]="selectedMobileGridLayout()" [productInput]="product?._source!"></product-card-square>
                    }
                    }
                    @if (currentGridViewLayout() === gridViewLayout.GRID_VIEW_LAYOUT3) {
                    @for (product of products(); track product?._id) {
                    <product-card-rectangular [categoryLayoutData]="categoryLayoutData()" [productInput]="product?._source!"></product-card-rectangular>
                    }
                    }
                </div>

                <!-- pagination layout -->
                @if (paginationOptions() && paginationOptions()!.length > 1 && paginationType() === PaginationType.PAGE) {
                <pagination-layout-1 [paginationOptions]="paginationOptions()" [currentPageIndex]="currentPage()"></pagination-layout-1>
                }

                <!--product listing loader -->
                @if (listLoading()) {
                <base-listing-loader></base-listing-loader>
                }
                }
            </section>

            @if (productLoading()) {
            <base-listing-loader></base-listing-loader>
            }
            @if (!productLoading() && !products().length && currentAppliedFilters().length) {
            <webstore-listing-empty-state [currentSection]="category()"></webstore-listing-empty-state>
            }
        </div>
    </div>
</div>

@if (pageLoading() === null || pageLoading()) {
<category-page-shimmer [layoutType]="CategoryLayoutType.LAYOUT_02"></category-page-shimmer>
}
@if (pageLoading() !== null && !pageLoading() && !products().length && !currentAppliedFilters().length) {
<webstore-listing-empty-state [currentSection]="category()"></webstore-listing-empty-state>
}